<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/home">首页</shBreadItem>
      <shBreadItem to="/video">视频</shBreadItem>
      <shBreadItem v-if="firstlist" :to="`/video?firstCate=${menulist.chID}`">{{
        firstlist.chName
      }}</shBreadItem>
      <shBreadItem
        v-if="secondlist"
        :to="`/video?firstCate=${menulist.chID}&secondCate=${menulist.coID}`"
        >{{ secondlist.coName }}</shBreadItem
      >
      <shBreadItem
        ><div v-if="videoData" class="bread">
          {{ videoData[0]?.grade[0]?.grYear }}{{ videoData[0]?.leName }}
        </div></shBreadItem
      >
    </shBread>
  </div>
  <div class="video-detail"><VideoDesc :videoData="videoData" /></div>
  <div class="player-detail">
    <div class="player-desc">
      <ShTabs v-model="activeName">
        <ShTabsPanel label="课程详情" name="videoDesc">
          <VideoImg :videoData="videoData" />
        </ShTabsPanel>
        <ShTabsPanel label="课程目录" name="videoCatalog"
          ><VideoContent :videoData="videoData"
        /></ShTabsPanel>
        <ShTabsPanel label="考试大纲" name="videoOutline"
          ><VideoOutline :videoData="videoData"
        /></ShTabsPanel>
        <ShTabsPanel label="备考建议" name="videoAdvice"
          ><VideoAdvice :videoData="videoData"
        /></ShTabsPanel>
        <ShTabsPanel label="讲师介绍" name="videoTeach"
          ><VideoTeacher :videoData="videoData"
        /></ShTabsPanel>
      </ShTabs>
    </div>
    <div class="player-reco">
      <VideoReCommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { findVideoDetail, findVideoRecommand } from "@/api/video";
import VideoContent from "./compontents/video-content.vue";
import VideoImg from "./compontents/video-img.vue";
import VideoTeacher from "./compontents/video-teacher.vue";
import VideoDesc from "./compontents/video-desc.vue";
import VideoOutline from "./compontents/video-outline.vue";
import VideoAdvice from "./compontents/video-advice.vue";
import VideoReCommend from "@/components/video-recommend.vue";
import { useRouter, useRoute } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    VideoContent,
    VideoImg,
    VideoTeacher,
    VideoDesc,
    VideoReCommend,
    VideoOutline,
    VideoAdvice,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const activeName = ref("videoDesc");
    const videoData = ref([]);
    const VideoReCommend = ref([]);

    //console.log(typeof route.query.clID);

    findVideoDetail(route.query.id)
      .then((data) => {
        //console.log(data);
        videoData.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    const clID = route.query.clID.split(",");
    //console.log(clID);
    findVideoRecommand(clID)
      .then((data) => {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });

    const menulist = computed(() => {
      return store.state.category.list.find(
        (item) => item.clID === parseInt(clID)
      );
    });
    //console.log(menulist);
    const secondlist = computed(() => {
      return store.state.category.list.find(
        (item) => item.coID === parseInt(menulist.value.coID)
      );
    });
    const firstlist = computed(() => {
      return store.state.category.list.find(
        (item) => item.chID === parseInt(menulist.value.chID)
      );
    });
    //console.log(firstlist);
    return {
      activeName,
      videoData,
      VideoReCommend,
      menulist,
      secondlist,
      firstlist,
    };
  },
};
</script>

<style lang="less" scoped>
.news-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  //margin-bottom: 15px;
}
.video-detail {
  width: 1240px;
  margin: 0 auto;
}
.player-detail {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  margin: 50px auto;

  .player-desc {
    width: 850px;
    border-radius: 5px;
    background: #fff;
  }
  .player-reco {
    width: 350px;
    border-radius: 5px;
    background: #fff;
  }
}
</style>
